import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// The Contact module's mark: light-blue circle with the first letter, exactly
// as the contact detail page draws it — recognisably the same kind of thing
// everywhere a contact appears (distinct from the employee gradient and the
// neutral company avatar).
const ContactAvatar = ({ name }) => (
  <span className="tw-flex tw-items-center tw-justify-center tw-w-[22px] tw-h-[22px] tw-shrink-0 tw-rounded-full tw-bg-blue-100 tw-text-blue-600 tw-text-[10px] tw-font-bold tw-select-none">
    {(String(name).trim()[0] || '?').toUpperCase()}
  </span>
);
ContactAvatar.propTypes = { name: PropTypes.string };

// Links a contact cell to its detail page. `withAvatar` leads the cell with
// the contact mark.
const ContactLink = ({ value, data, withAvatar = false }) => {
  if (!data?.id || !value) return value || null;

  const link = (
    <Link to={`/crm/contacts/${data.id}`} className="tw-truncate">
      {value}
    </Link>
  );

  if (!withAvatar) return link;

  return (
    <span className="tw-inline-flex tw-items-center tw-gap-2 tw-max-w-full">
      <ContactAvatar name={value} />
      {link}
    </span>
  );
};

ContactLink.propTypes = {
  value: PropTypes.node,
  data: PropTypes.object,
  withAvatar: PropTypes.bool
};

export default ContactLink;
